/*! customs-libs 2022-10-21 */

!function(e) {
    if ("object" == typeof exports && "undefined" != typeof module) module.exports = e(); else if ("function" == typeof define && define.amd) define([], e); else {
        ("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).customsLibs = e();
    }
}(function() {
    return function a(o, u, f) {
        function s(t, e) {
            if (!u[t]) {
                if (!o[t]) {
                    var n = "function" == typeof require && require;
                    if (!e && n) return n(t, !0);
                    if (l) return l(t, !0);
                    var i = new Error("Cannot find module '" + t + "'");
                    throw i.code = "MODULE_NOT_FOUND", i;
                }
                var r = u[t] = {
                    exports: {}
                };
                o[t][0].call(r.exports, function(e) {
                    return s(o[t][1][e] || e);
                }, r, r.exports, a, o, u, f);
            }
            return u[t].exports;
        }
        for (var l = "function" == typeof require && require, e = 0; e < f.length; e++) s(f[e]);
        return s;
    }({
        1: [ function(e, t, n) {
            "use strict";
            Object.defineProperty(n, "__esModule", {
                value: !0
            });
            n.default = {
                maxSize: "10485760",
                minimumDimensions: [ 100, 100 ],
                supportedMimeTypes: [ "image/jpeg", "image/jpg", "image/png" ]
            };
        }, {} ],
        2: [ function(e, t, n) {
            "use strict";
            var i = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            };
            Object.defineProperty(n, "__esModule", {
                value: !0
            });
            var r = i(e("./libs")), a = i(e("./const/imageConfigObj"));
            n.default = function e() {
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, e), this.Libs = r.default, this.imageRequirements = a.default;
            };
        }, {
            "./const/imageConfigObj": 1,
            "./libs": 5
        } ],
        3: [ function(e, t, n) {
            "use strict";
            var i = function() {
                function i(e, t) {
                    for (var n = 0; n < t.length; n++) {
                        var i = t[n];
                        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), 
                        Object.defineProperty(e, i.key, i);
                    }
                }
                return function(e, t, n) {
                    return t && i(e.prototype, t), n && i(e, n), e;
                };
            }();
            Object.defineProperty(n, "__esModule", {
                value: !0
            });
            var r = function() {
                function e() {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                }
                return i(e, [ {
                    key: "cropImage",
                    value: function(e) {
                        var t = e.width, n = e.height, i = e.SQUARE_IMG_DIMENSION, r = void 0 === i ? 1024 : i;
                        if (!t || !n) return new Error("width and height parameters are required.");
                        var a = r, o = r;
                        return (n < r || t < r) && n < (o = a = t) && (o = a = n), {
                            cropWidth: a,
                            cropHeight: o
                        };
                    }
                } ]), e;
            }();
            n.default = r;
        }, {} ],
        4: [ function(e, t, n) {
            "use strict";
            var r = function() {
                function i(e, t) {
                    for (var n = 0; n < t.length; n++) {
                        var i = t[n];
                        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), 
                        Object.defineProperty(e, i.key, i);
                    }
                }
                return function(e, t, n) {
                    return t && i(e.prototype, t), n && i(e, n), e;
                };
            }();
            Object.defineProperty(n, "__esModule", {
                value: !0
            });
            var i = function() {
                function i(e, t, n) {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, i), this.validateImageProperties(e, t, n);
                }
                return r(i, [ {
                    key: "validateDimensions",
                    value: function(e, t) {
                        return e.width >= t[0] && e.height >= t[1];
                    }
                }, {
                    key: "validateImageSize",
                    value: function(e, t) {
                        return e.size <= t;
                    }
                }, {
                    key: "validateImageType",
                    value: function(e, t) {
                        return t.includes(e.type);
                    }
                }, {
                    key: "validateExtension",
                    value: function(e) {
                        var t, n = null === (t = e.name) || void 0 === t ? void 0 : t.substr(e.name.lastIndexOf(".")).replace(".", "").toLowerCase(), i = e.type.indexOf("/") ? e.type.split("/")[1] : e.type;
                        return n && "jpeg" === n && (n = "jpg"), "jpeg" === i && (i = "jpg"), n && n !== i ? {
                            isExtDiffFromOrigin: !0,
                            filename: e.name.substr(0, e.name.lastIndexOf(".")) + "." + i
                        } : {
                            isExtDiffFromOrigin: !1
                        };
                    }
                }, {
                    key: "validateImageProperties",
                    value: function(e, t, n) {
                        var i = this.validateDimensions(t, n.minimumDimensions), r = this.validateImageSize(e, n.maxSize), a = this.validateImageType(e, n.supportedMimeTypes), o = this.validateExtension(e);
                        this.imageStatus = {
                            imageDimensions: i,
                            imageSize: r,
                            imageType: a,
                            ext: o
                        };
                    }
                } ]), i;
            }();
            n.default = i;
        }, {} ],
        5: [ function(e, t, n) {
            "use strict";
            var i = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            };
            Object.defineProperty(n, "__esModule", {
                value: !0
            });
            var r = i(e("./ValidateImage")), a = i(e("./CustomImageDimension"));
            n.default = {
                ValidateImage: r.default,
                CustomImageDimension: a.default
            };
        }, {
            "./CustomImageDimension": 3,
            "./ValidateImage": 4
        } ]
    }, {}, [ 2 ])(2);
});